import { useState } from "react";
import { CalendarPlus, FilePlus2, FileSignature, Plus, UserPlus, Users, X } from "lucide-react";

const ITEMS = [
  ["customer", "Yeni Müşteri", Users],
  ["lead", "Yeni Potansiyel Müşteri Adayı", UserPlus],
  ["appointment", "Yeni Randevu", CalendarPlus],
  ["quote", "Yeni Teklif", FileSignature],
  ["policy", "Yeni Poliçe", FilePlus2],
];

export function QuickAddFab({ onPick }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`fab-wrap${open ? " open" : ""}`} data-testid="quick-add-fab">
      {open && <div className="fab-scrim" onClick={() => setOpen(false)} />}
      {open && (
        <ul className="fab-menu" data-testid="quick-add-menu">
          {ITEMS.map(([k, label, Icon], i) => (
            <li key={k} style={{ animationDelay: `${(ITEMS.length - i) * 30}ms` }}>
              <button type="button" onClick={() => { setOpen(false); onPick(k); }} data-testid={`quick-add-${k}`}><span>{label}</span><i><Icon size={17} /></i></button>
            </li>
          ))}
        </ul>
      )}
      <button type="button" className="fab-button" onClick={() => setOpen((o) => !o)} aria-label="Hızlı ekle" data-testid="quick-add-button">
        {open ? <X size={24} /> : <Plus size={26} />}
      </button>
    </div>
  );
}
